export const ProgressBar = ({ progress, message }) => {
  return (
    <div className="absolute bottom-6 right-6 z-40 pointer-events-auto" data-testid="progress-bar">
      <div className="bg-zinc-950/95 backdrop-blur-md border border-emerald-500/50 p-5 rounded-sm shadow-2xl w-80">
        <div className="flex items-center gap-3 mb-4">
          <div className="w-5 h-5 rounded-full border-2 border-emerald-400 border-t-transparent animate-spin" />
          <div className="font-barlow text-emerald-400 uppercase font-bold text-sm">Analyse en cours</div>
        </div>
        
        {/* Progress Bar */}
        <div className="relative h-3 bg-zinc-900 rounded-sm overflow-hidden mb-3">
          <div
            className="absolute inset-y-0 left-0 bg-gradient-to-r from-emerald-500 to-cyan-500 transition-all duration-300 ease-out"
            style={{ width: `${progress}%` }}
          >
            <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/20 to-transparent animate-shimmer" />
          </div>
        </div>
        
        {/* Progress Info */}
        <div className="flex items-center justify-between">
          <span className="font-mono text-xs text-zinc-400" data-testid="progress-message">{message}</span>
          <span className="font-mono text-cyan-400 font-bold" data-testid="progress-percentage">{Math.round(progress)}%</span>
        </div>
      </div>
    </div>
  );
};
